import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, vModelText as _vModelText, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 mb-20" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "mb-15 mb-sm-0 d-sm-flex align-items-center justify-content-between" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "card-title fw-black mb-0" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_10 = ["value"]
const _hoisted_11 = {
  class: "col-12 col-md-6 mb-3",
  style: {"margin-top":"3%"}
}
const _hoisted_12 = {
  class: "col-12 col-md-6 mb-3",
  style: {"margin-top":"3%"}
}
const _hoisted_13 = {
  for: "replace1",
  class: "form-check-label"
}
const _hoisted_14 = {
  key: 0,
  style: {"font-size":"12px"}
}
const _hoisted_15 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_16 = {
  key: 0,
  class: "text-error"
}
const _hoisted_17 = {
  key: 1,
  class: "text-error"
}
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_20 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_21 = {
  key: 0,
  class: "col-12 col-md-6 mb-3"
}
const _hoisted_22 = {
  key: 1,
  class: "col-12 col-md-6 mb-3"
}
const _hoisted_23 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_24 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_25 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_26 = { class: "col-12 col-md-4 mb-3" }
const _hoisted_27 = { class: "col-12 col-md-4 mb-3" }
const _hoisted_28 = { class: "col-12 col-md-4 mb-3" }
const _hoisted_29 = { class: "col-12 mb-10" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_32 = { class: "col-12" }
const _hoisted_33 = { class: "col-12 col-md-4 mb-3" }
const _hoisted_34 = ["value"]
const _hoisted_35 = { class: "col-12 col-md-4 mb-3" }
const _hoisted_36 = { class: "col-12 col-md-4 mb-3" }
const _hoisted_37 = { class: "col-12" }
const _hoisted_38 = { class: "col-12" }
const _hoisted_39 = {
  key: 3,
  class: "col-12"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_center = _resolveComponent("center")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.form.code), 1)
        ])
      ]),
      _createElementVNode("form", null, [
        _createElementVNode("div", _hoisted_6, [
          (_ctx.row.invoiced != 1)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[22] || (_cache[22] = _createElementVNode("label", { for: "colis" }, "Colis", -1)),
                  _withDirectives(_createElementVNode("select", {
                    id: "colis",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.OpenColi) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ColisList, (option) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: option.value,
                        value: option.value
                      }, _toDisplayString(option.text), 9, _hoisted_8))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.OpenColi]
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _cache[23] || (_cache[23] = _createElementVNode("label", { for: "fragile" }, "Fragile", -1)),
                  _withDirectives(_createElementVNode("select", {
                    id: "fragile",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.fragile) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.FragileColis, (option) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: option.value,
                        value: option.value
                      }, _toDisplayString(option.text), 9, _hoisted_10))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.fragile]
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                id: "replace0",
                value: "0",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ReplaceColis) = $event)),
                class: "form-check-input"
              }, null, 512), [
                [_vModelRadio, _ctx.ReplaceColis]
              ]),
              _cache[24] || (_cache[24] = _createElementVNode("label", {
                for: "replace0",
                class: "form-check-label"
              }, "Colis Simple", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                id: "replace1",
                value: "1",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.ReplaceColis) = $event)),
                class: "form-check-input"
              }, null, 512), [
                [_vModelRadio, _ctx.ReplaceColis]
              ]),
              _createElementVNode("label", _hoisted_13, [
                _cache[26] || (_cache[26] = _createTextVNode(" Colis Change ", -1)),
                (Number(_ctx.ReplaceColis) == 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, _cache[25] || (_cache[25] = [
                      _createElementVNode("br", null, null, -1),
                      _createTextVNode(" Le colis sera remplacer avec le colis : ", -1)
                    ])))
                  : _createCommentVNode("", true)
              ]),
              (Number(_ctx.ReplaceColis) == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      placeholder: "Code de suivi",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.code_replace) = $event)),
                      onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.SearchColis && _ctx.SearchColis(...args)))
                    }, null, 544), [
                      [_vModelText, _ctx.form.code_replace]
                    ]),
                    (_ctx.existcolis)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_16, "Ce colis n'existe pas"))
                      : _createCommentVNode("", true),
                    (_ctx.replacecolis)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_17, "Vous pouvez pas remplacer ce colis"))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _cache[27] || (_cache[27] = _createElementVNode("div", { class: "col-12" }, [
            _createElementVNode("hr")
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_18, [
          (_ctx.row.invoiced != 1)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_19, [
                  _cache[28] || (_cache[28] = _createElementVNode("label", { for: "dest" }, "Destinataire", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "dest",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.receiver) = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.form.receiver]
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _cache[29] || (_cache[29] = _createElementVNode("label", { for: "phone" }, "Téléphone", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "phone",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.phone) = $event)),
                    type: "number",
                    pattern: "^([0][0-9]{9})$",
                    onKeypress: _cache[8] || (_cache[8] = ($event: any) => {
                  if (isNaN(Number($event.key))) $event.preventDefault();
                })
                  }, null, 544), [
                    [_vModelText, _ctx.form.phone]
                  ])
                ]),
                (_ctx.auth.can('PARCELS_EDIT_CITY'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _cache[30] || (_cache[30] = _createElementVNode("label", { for: "city" }, "Ville", -1)),
                      _createVNode(_component_v_select, {
                        class: "custom-select-height",
                        id: "city",
                        required: "",
                        label: "name",
                        modelValue: _ctx.city,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.city) = $event)),
                        options: _ctx.CitiesList,
                        placeholder: "Ville",
                        onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showFees(_ctx.city)))
                      }, null, 8, ["modelValue", "options"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_22)),
                _createElementVNode("div", _hoisted_23, [
                  _cache[31] || (_cache[31] = _createElementVNode("label", { for: "price" }, "Prix", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "price",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.price) = $event)),
                    disabled: ""
                  }, null, 512), [
                    [_vModelText, _ctx.form.price]
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _cache[32] || (_cache[32] = _createElementVNode("label", { for: "adresse" }, "Adresse", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    name: "adresse",
                    rows: "3",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.address) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.form.address]
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _cache[33] || (_cache[33] = _createElementVNode("label", { for: "comment" }, "Commentaire", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    name: "comment",
                    rows: "3",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.note) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.form.note]
                  ])
                ]),
                (_ctx.auth.can('PARCELS') && _ctx.auth.can('EDIT_FEES_PARCELS'))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createElementVNode("div", _hoisted_26, [
                        _cache[34] || (_cache[34] = _createElementVNode("label", { for: "fl" }, "Frais de livraison *", -1)),
                        _withDirectives(_createElementVNode("input", {
                          style: {"color":"#f14d12"},
                          id: "fl",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.delivered_fees) = $event)),
                          disabled: ""
                        }, null, 512), [
                          [_vModelText, _ctx.form.delivered_fees]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _cache[35] || (_cache[35] = _createElementVNode("label", { for: "frn" }, "Frais de retour *", -1)),
                        _withDirectives(_createElementVNode("input", {
                          style: {"color":"#f14d12"},
                          id: "frn",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.returned_fees) = $event)),
                          disabled: ""
                        }, null, 512), [
                          [_vModelText, _ctx.form.returned_fees]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _cache[36] || (_cache[36] = _createElementVNode("label", { for: "frs" }, "Frais de refus *", -1)),
                        _withDirectives(_createElementVNode("input", {
                          style: {"color":"#f14d12"},
                          id: "frs",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.refused_fees) = $event)),
                          disabled: ""
                        }, null, 512), [
                          [_vModelText, _ctx.form.refused_fees]
                        ])
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_29, [
            (_ctx.auth.can('PARCELS'))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-primary float-right mb-1 mb-sm-0 mr-0 mr-sm-1",
                  disabled: _ctx.load || _ctx.isload,
                  onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.AddColis && _ctx.AddColis(...args)))
                }, [
                  _cache[37] || (_cache[37] = _createTextVNode(" Enregistrer ", -1)),
                  (_ctx.load || _ctx.isload)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_31))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_30))
              : _createCommentVNode("", true)
          ]),
          (
              (_ctx.row.status == 'DELIVERED' ||
                _ctx.row.status == 'DELIVERED_PARTIAL') &&
              _ctx.row.paid_livreur == 0 &&
              _ctx.row.livreur != 0 &&
              _ctx.row.invoiced != 1
            )
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _cache[41] || (_cache[41] = _createElementVNode("div", { class: "col-12" }, [
                  _createElementVNode("hr")
                ], -1)),
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_center, null, {
                    default: _withCtx(() => _cache[38] || (_cache[38] = [
                      _createElementVNode("h2", null, [
                        _createElementVNode("b", null, "Changer le livreur")
                      ], -1)
                    ])),
                    _: 1,
                    __: [38]
                  })
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _cache[39] || (_cache[39] = _createElementVNode("label", null, "Ancien Livreur", -1)),
                  _createElementVNode("input", {
                    class: "form-control",
                    style: {"color":"#f14d12"},
                    value: 
                  _ctx.row.driver && _ctx.row.driver.livreur_name
                    ? _ctx.row.driver.livreur_name
                    : _ctx.row.livreur_name
                ,
                    disabled: ""
                  }, null, 8, _hoisted_34)
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _cache[40] || (_cache[40] = _createElementVNode("label", null, "Nouveau Livreur", -1)),
                  _createVNode(_component_v_select, {
                    class: "custom-select-height",
                    required: "",
                    label: "name",
                    modelValue: _ctx.livreur,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.livreur) = $event)),
                    options: _ctx.LivsList,
                    placeholder: "Ville"
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  (_ctx.auth.can('PARCELS'))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-primary mb-1 mb-sm-0 mr-0 mr-sm-1",
                        onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.EditLivreur && _ctx.EditLivreur(...args))),
                        style: {"margin-top":"6%"}
                      }, " Modifier "))
                    : _createCommentVNode("", true)
                ])
              ], 64))
            : _createCommentVNode("", true),
          (
              _ctx.auth.can('PARCELS') &&
              (_ctx.user?.role_id == 1 || _ctx.user?.role_id == 2) &&
              (_ctx.row.status == 'DELIVERED' ||
                _ctx.row.status == 'DELIVERED_PARTIAL') &&
              _ctx.row.situation != 'INVOICED' &&
              _ctx.row.invoiced != 1
            )
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _cache[43] || (_cache[43] = _createElementVNode("div", { class: "col-12" }, [
                  _createElementVNode("hr")
                ], -1)),
                _createElementVNode("div", _hoisted_37, [
                  _createVNode(_component_center, null, {
                    default: _withCtx(() => _cache[42] || (_cache[42] = [
                      _createElementVNode("h2", null, [
                        _createElementVNode("b", null, "Colis non livré")
                      ], -1)
                    ])),
                    _: 1,
                    __: [42]
                  })
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _createVNode(_component_center, null, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary mb-1 mb-sm-0 mr-0 mr-sm-1",
                        onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.EditLivredStatut && _ctx.EditLivredStatut(...args))),
                        style: {"margin-top":"1%"},
                        title: "Modifier status (Non Livré)"
                      }, " Colis non livré ")
                    ]),
                    _: 1
                  })
                ])
              ], 64))
            : _createCommentVNode("", true),
          (
              _ctx.row.status == 'IN_PROGRESS' &&
              _ctx.row.status_second == 'REFUSE' &&
              _ctx.row.situation == 'Facturé' &&
              _ctx.row.invoiced == 1
            )
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                _createVNode(_component_center, null, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary mb-1 mb-sm-0 mr-0 mr-sm-1",
                      onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.ToDistribution && _ctx.ToDistribution(...args))),
                      style: {"margin-top":"1%"},
                      title: "Modifier status (Non Livré)"
                    }, " Changer en mise en distribution ")
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}